import "./style.scss";

import IosSwitch from "../IosSwitch";

type TProps = {
    name: string;
    handleChange: any;
    setIsEdited?: any;
    title: string;
    description: string;
    value: boolean;
};

const SettingBoolean = (props: TProps) => {
    const { title, description, name, value, handleChange, setIsEdited } = props;

    const handleDataChange = (value: boolean) => {
        setIsEdited && setIsEdited(true);
        handleChange(value);
    };

    return (
        <div className="setting-boolean">
            <div className="setting-left">
                <div className="setting-title">{title}</div>
                <div className="setting-description">{description}</div>
            </div>
            <div className="setting-right">
                <IosSwitch
                    size="medium"
                    name={name}
                    checked={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDataChange(e.target.checked)}
                />
            </div>
        </div>
    );
};

export default SettingBoolean;
